import { render, staticRenderFns } from "./crudDoubleQuerys.vue?vue&type=template&id=d9e2d7c4&scoped=true"
import script from "./crudDoubleQuerys.vue?vue&type=script&lang=js"
export * from "./crudDoubleQuerys.vue?vue&type=script&lang=js"
import style0 from "./crudDoubleQuerys.vue?vue&type=style&index=0&id=d9e2d7c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e2d7c4",
  null
  
)

export default component.exports